// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound_root__3zXRU","text":"NotFound_text__uy71R","svg":"NotFound_svg__3D-8K"};